import React from 'react';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

export function Success ({ children }) {
  return (
    <Alert variant="success">
      <Alert.Heading>Sucesso</Alert.Heading>
      <p>{children}</p>
    </Alert>
  );
}
Success.propTypes = {
  children: PropTypes.node.isRequired,
};
